export enum TaxType {
    Iva = 1,
    IIBB = 2,
}
